import { Button, Form, Input, Select, Space, message, Spin } from 'antd';
import { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Link } from 'react-router-dom';

interface EquipoData {
    id: number;
    sector: {
        id: number;
        descripcion: string;
    };
    descripcion: string;
    alta: number;
  }

interface SectorData {
    id: number;
    descripcion: string;
    alta: number;
  }
  

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};

const tailLayout = {
  wrapperCol: { offset: 8, span: 16 },
};

const CrearMotores: React.FC = () => {
  // Primero las declaraciones de Auth0
  const [form] = Form.useForm();
  const { getAccessTokenSilently , isLoading } = useAuth0();
  const { user } = useAuth0();
  const empresa = user?.id_empresa; 
  const sucursal = user?.id_sucursal;
  const [buttonLoading, setButtonLoading] = useState(false);
  const [sectores, setSectores] = useState<SectorData[]>([]);
  const [equipos, setEquipos] = useState<EquipoData[]>([]);
  const [loadingSectores, setLoadingSectores] = useState(false);
  const [loadingEquipos, setLoadingEquipos] = useState(false);
  const [componentLoading, setComponentLoading] = useState(true);

  const fetchSectores = async () => {
    setLoadingSectores(true);
    try {
      const accessToken = await getAccessTokenSilently();
      console.log('pasoxaqui', empresa,sucursal);
      const response = await fetch(`${process.env.REACT_APP_INSUMOS_URL}/listar_sectores/${empresa}/${sucursal}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accessToken}`,
        },
      });
      console.log('response', response);

      if (!response.ok) {
        throw new Error('Error al cargar los sectores');
      }

      const data = await response.json();
      // Filtrar solo los registros con clasificacion = 3 (Marca)
    /*  setFilteredEquipos(equiposFiltrados);*/
      const soloSectores = data.filter((item: SectorData) => item.alta === 1);
      setSectores(soloSectores);
    } catch (error) {
      console.error('Error:', error);
      message.error('Error al cargar los sectores');
    } finally {
      setLoadingSectores(false);
    }
  };
  
useEffect(() => {
    const initializeComponent = async () => {
      if (isLoading) {
        return;
      }

      if (!user || !empresa || !sucursal) {
        message.error('Error: No se encontraron datos del usuario');
        setComponentLoading(false);
        return;
      }

      try {
        await fetchSectores();
      } catch (error) {
        console.error('Error initializing component:', error);
      } finally {
        setComponentLoading(false);
      }
    };

    initializeComponent();
  }, [isLoading, user, empresa, sucursal]);

  // If component is loading, show spinner
  if (componentLoading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <Spin size="large" tip="Cargando..." />
      </div>
    );
  }

  const fetchEquipos = async (sectorId: number) => {
    setLoadingEquipos(true);
    try {
      const accessToken = await getAccessTokenSilently();
      const response = await fetch(`${process.env.REACT_APP_INSUMOS_URL}/listar_equipos_por_sector/${empresa}/${sucursal}/${sectorId}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accessToken}`,
        },
      });

      if (!response.ok) {
        throw new Error('Error al cargar los equipos');
      }

      const data = await response.json();
      const soloEquipos = data.filter((item: EquipoData) => 
        item.alta === 1 && 
        item.sector.id === sectorId
      );
      
      console.log('sectorId:', sectorId);
      console.log('Equipos filtrados:', soloEquipos);
      console.log('Todos los equipos:', data);
      
      setEquipos(soloEquipos);
    } catch (error) {
      console.error('Error:', error);
      message.error('Error al cargar los equipos');
    } finally {
      setLoadingEquipos(false);
    }
  };

  // Cargar las marcas cuando el componente se monta
  
  const handleAdd = () => {
    setButtonLoading(true);
    form.validateFields().then(async (values) => {
      try {
        const accessToken = await getAccessTokenSilently();
        const response = await fetch(`${process.env.REACT_APP_INSUMOS_URL}/crear_motores`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`,
          },
          body: JSON.stringify({
            ...values,
            id_empresa: empresa, // Asume que tienes un ID de empresa, ajusta según sea necesario
            id_sucursal: sucursal
          }),
        });
        if (!response.ok) {
          
          throw new Error('Network response was not ok');
        }
        message.success('Motores añadido correctamente');
        form.resetFields();
      } catch (error) {
        console.error('Error adding motores:', error);
        message.error(`Error al añadir el motores:${error}`);
      } finally {
        setButtonLoading(false);
      }
    });
  };



  const onFinish = (values: any) => {
    console.log(values);
  };

  return (
    <Form
      {...layout}
      form={form}
      name="control-hooks"
      onFinish={onFinish}
      style={{ maxWidth: 600}}
    >
      <Form.Item name="descripcion" label="Descripcion" rules={[{ required: true }]}>
        <Input maxLength={40} showCount />
      </Form.Item>
      <Form.Item 
        name="id_sector" 
        label="Sector" 
        rules={[{ required: true, message: 'Por favor seleccione un sector' }]}
      >
        <Select
          placeholder="Seleccione un sector"
          loading={loadingSectores}
          onChange={fetchEquipos}
          showSearch
          optionFilterProp="children"
          filterOption={(input, option) =>
            (option?.children as unknown as string)
              .toLowerCase()
              .includes(input.toLowerCase())
          }
        >
          {sectores.map(sector => (
            <Select.Option key={sector.id} value={sector.id}>
              {sector.descripcion}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item 
        name="id_equipo" 
        label="Equipo" 
        rules={[{ required: true, message: 'Por favor seleccione un equipo' }]}
      >
        <Select
          placeholder="Seleccione un equipo"
          loading={loadingEquipos}
          showSearch
          disabled={!form.getFieldValue('id_sector')}  // Deshabilitar hasta que se seleccione sector
          optionFilterProp="children"
          filterOption={(input, option) =>
            (option?.children as unknown as string)
              .toLowerCase()
              .includes(input.toLowerCase())
          }
        >
          {equipos.map(equipo => (
            <Select.Option key={equipo.id} value={equipo.id}>
              {equipo.descripcion}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item {...tailLayout}>
        <Space>
          <Button 
          type="primary" 
          htmlType="submit"
          onClick={handleAdd}
          loading={buttonLoading}
          disabled={buttonLoading}
          >
            {buttonLoading ? 'Guardando...' : 'Guardar'}
          </Button>
           <Button type="default"><Link to= {`/listar_motores`}>
            Listar
          </Link>
          </Button>
        </Space>
      </Form.Item>
    </Form>
  );
};

export default CrearMotores;